// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-AddressForm__addressSelect__root"};